//"use client";

import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "c570472246df5796c8821ba6e735a160Tz0xMTg5ODYsRT0xNzg5MjU3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

export default function MuiXLicense() {
  //console.log("Rendering MuiXLicense");
  return null;
}
